// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.


/// <summary>
/// Базовый класс для серии данных
/// </summary>
export let TerceraChartBaseSeries = function ()
{

}
/// <summary>
/// Получить значение указанного объекта
/// </summary>               
TerceraChartBaseSeries.prototype.GetValue = function (index, level)
{
    return 0;
};

/// <summary>
/// Количество объектов
/// </summary>
TerceraChartBaseSeries.prototype.Count = function ()
{
    return 0;
};

TerceraChartBaseSeries.prototype.Length = function ()
{
    return 0;
};

TerceraChartBaseSeries.prototype.Dispose = function ()
{

};